<template>
    <COProfiles></COProfiles>
</template>

<script>
  import COProfiles from "@/components/pages/affiliates/profiles/COProfiles";

  export default {
    components: {
      COProfiles,
    },
  }
</script>

<style scoped lang="sass">
.search_btn_wrap
  .search_wrapper
    width: 250px
    padding-bottom: 15px
</style>
